import React from "react";
import { Button, useDisclosure } from "@chakra-ui/core";
import Signup from "../authentication/SignupAndLogin";

function CallToAction() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        my="5px"
        w="50%"
        minW="300px"
        size="lg"
        color="#FFFFFF"
        bg="success.500"
        _hover={{ background: "#0F8D45" }}
        onClick={onOpen}
        textTransform="uppercase"
        fontWeight="bold"
      >
        Get paid now
      </Button>
      <Signup {...{ isOpen, onClose }} />
    </>
  );
}

export default CallToAction;
